import { render, staticRenderFns } from "./deckListVertical.vue?vue&type=template&id=6663d60c&scoped=true&"
import script from "./deckListVertical.vue?vue&type=script&lang=js&"
export * from "./deckListVertical.vue?vue&type=script&lang=js&"
import style0 from "./deckListVertical.vue?vue&type=style&index=0&id=6663d60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6663d60c",
  null
  
)

export default component.exports